import {combineReducers} from '@modifi/redux'

import dataSourceReducer from './store/data-source'
import formReducer from './store/form'

export default combineReducers({
  dataSource: dataSourceReducer,
  form: formReducer,
})
